var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAllineone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-allineone",
    transform: "translate(-2245 -10229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 40,
    height: 40,
    transform: "translate(2245 10229)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico_allinone",
    d: "M38.021,12H5.065A3.077,3.077,0,0,0,2,15.086V35.657a3.077,3.077,0,0,0,3.065,3.086H17.429v3.6h-.771a.771.771,0,0,0,0,1.543h9.771a.771.771,0,1,0,0-1.543h-.771v-3.6H38.021a3.077,3.077,0,0,0,3.065-3.086V15.086A3.077,3.077,0,0,0,38.021,12ZM24.114,42.343H18.971v-3.6h5.143Zm15.429-6.686A1.53,1.53,0,0,1,38.021,37.2H5.065a1.533,1.533,0,0,1-1.522-1.543V34.629h36Zm0-2.571h-36v-18a1.53,1.53,0,0,1,1.522-1.543H38.021a1.533,1.533,0,0,1,1.522,1.543ZM22.571,16.114a1.029,1.029,0,1,1-1.029-1.029A1.032,1.032,0,0,1,22.571,16.114Z",
    transform: "translate(2243.457 10221)",
    fill: "#646464"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAllineone);
export default __webpack_public_path__ + "static/media/ico-allineone.df2a5b24af641652d34904ef13c5a247.svg";
export { ForwardRef as ReactComponent };